import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const folderNameMap: any = {
  "simple-dyte-client": "simpleDyteClient",
  "custom-layout": "customLayout",
};

const { REACT_APP_MY_BACKEND: MY_BACKEND } = process.env;

export const LobbyComponent = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [allMeeetings, setAllMeeting] = useState<any[]>([]);
  const [newMeetingTitle, setNewMeetingTitle] = useState<string>("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedExample, setSelectedExample] =
    useState<string>("simple-dyte-client");

  const params = useParams<{ id: any; room: any; title: string }>();

  console.log(isChecked);
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  let navigate = useNavigate();
  const joinRoom = async (
    meetingId: any,
    roomName: any,
    isHost: boolean = false
  ) => {
    const apiKEY = process.env.REACT_APP_DYTE_API_KEY;
    const orgID = process.env.REACT_APP_DYTE_ORG_ID;
    const baseURL = process.env.REACT_APP_DYTE_API_BASE_URL;
    const resp = await axios({
      url: `${baseURL}/organizations/${orgID}/meetings/${meetingId}/participant`,
      method: "POST",
      headers: {
        Authorization: `APIKEY ${apiKEY}`,
      },
      data: {
        clientSpecificId: Math.random().toString(36).substring(7),
      },
    });

    const authResponse = resp.data.data.authResponse;
    const authToken = authResponse.authToken;

    //saving meeting details in session storage
    sessionStorage.setItem("auth", authToken);
    sessionStorage.setItem("meetingID", meetingId);
    sessionStorage.setItem("roomName", roomName);
    sessionStorage.setItem("blurr", isChecked ? "true" : "false");

    // redirecting to the example meeting page
    navigate(`/${selectedExample}/meeting/${roomName}/${meetingId}`);
  };

  return (
    <div id="wrapper">
      <div id="left">
        <h1>{params.title}</h1>
      </div>
      <div id="right">
        <button
          style={{ marginTop: "30px", marginRight: "20px" }}
          onClick={() => joinRoom(params.id, params.room, true)}
        >
          Join as Host
        </button>
        <button
          style={{ marginTop: "30px", marginLeft: "20px" }}
          onClick={() => joinRoom(params.id, params.room)}
        >
          Join as participant
        </button>
        <br />
        <br />
        <input
          type="checkbox"
          id="topping"
          name="topping"
          value="Paneer"
          checked={isChecked}
          onChange={handleOnChange}
        />
        <strong>Blur Background</strong>
      </div>
    </div>
    // <div className="main-screen-wrapper">

    //

    //   <div className="existing-meeting-wrapper ">
    //     <h5>Click to join as new participant or as a host.</h5>
    //     <div className="existing-meeting-list flex row meeting-list-wrapper" style={{ margin : "20px", }}>
    //         <button  style={{ marginRight : "20px", }}  onClick={() => joinRoom(params.id, params.room, true)} >Join as Host</button>
    //         <button  style={{ marginLeft : "20px", }} onClick={() => joinRoom(params.id, params.room)} >Join as participant</button>

    //     </div>

    //   </div>
    // </div>
  );
};
